import { render, staticRenderFns } from "./OrderTemplate.vue?vue&type=template&id=56d654d4&scoped=true"
import script from "./OrderTemplate.vue?vue&type=script&lang=js"
export * from "./OrderTemplate.vue?vue&type=script&lang=js"
import style0 from "./OrderTemplate.vue?vue&type=style&index=0&id=56d654d4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d654d4",
  null
  
)

export default component.exports